import values from 'lodash/values';

import { EFFECTS } from '../constants';

export default ({ enabled, value } = {}) => {
  if (!enabled) return null;

  return values(EFFECTS).find((name) => value === name);
};
